import { type BaseQueryFn } from '@reduxjs/toolkit/query';
import { type AxiosRequestConfig, type AxiosError } from 'axios';
import { getOpenedCharityId } from 'common/storage/openedCharityStorage';

import axios from './axios';

const CHARITY_SCOPED_URL = /^\/charity\/(donations\/v1\/(?!item-categories)|users\/v1\/(me|list)$)/;

const withOpenedCharity = (url: string, params?: Record<string, unknown>) => {
  const charityId = getOpenedCharityId();
  if (!charityId || !CHARITY_SCOPED_URL.test(url)) {
    return params;
  }
  return { ...params, charityId };
};

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: '/web' },
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig['method'];
      data?: unknown;
      params?: Record<string, unknown>;
      headers?: Record<string, string>;
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    try {
      const scopedParams = withOpenedCharity(url, params);
      const config: AxiosRequestConfig = {
        url: baseUrl + url,
        method,
        ...(data !== undefined && { data }),
        ...(scopedParams !== undefined && { params: scopedParams }),
        ...(headers !== undefined && { headers }),
      };
      const result = await axios<unknown>(config);
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,

          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosBaseQuery;
